import React, { useState, useEffect, useRef } from 'react';
import { ScrollView, View, Alert, Linking, Platform } from 'react-native';
import Contacts from 'react-native-contacts';

import { map as _map, get as _get } from 'lodash';
import PropTypes from 'prop-types';

import { VFText } from '@vfgroup-oneplatform/foundation/Components';
import { LightThemeColors, withTheme } from '@vfgroup-oneplatform/foundation/Components/Themes';
import ContentManager from '@vfgroup-oneplatform/foundation/ContentManager';
import PermissionsManager from '@vfgroup-oneplatform/foundation/PermissionsManager';
import {
  androidPermissionTypes,
  IOSPermissionTypes,
} from '@vfgroup-oneplatform/foundation/PermissionsManager/permissionTypes';
import { User_Types } from '@vfgroup-oneplatform/foundation/Utils/UserTypes.Enum';

import { SubTrayItemView } from '../../../CommonUI';
import NewRecipient from '../NewRecipient/NewRecipient';

import styles from './SelectedRecipient.Styles';

const checkContactsPermission = onContactListOpen => {
  const permissionType =
    Platform.OS === 'android'
      ? { [androidPermissionTypes.READ_CONTACTS]: true }
      : { [IOSPermissionTypes.CONTACTS]: true };
  // IOS only: check permission status if denied
  Contacts.checkPermission().then(permission => {
    if (permission === 'denied') {
      setTimeout(() => {
        Alert.alert(
          ContentManager.translate('contacts_permission_alert_title'),
          ContentManager.translate('contacts_permission_alert_message'),
          [
            {
              text: ContentManager.translate('contacts_permission_alert_cancel_title'),
            },
            {
              text: ContentManager.translate('contacts_permission_alert_confirm_title'),
              onPress: Linking.openSettings,
            },
          ],
          { cancelable: true },
        );
      }, 1);
    }
  });
  // request contacts permission by native popup
  requestContactsPermissions(permissionType).then(result => {
    // make sure that contacts permission is allowed
    if (result[Object.keys(permissionType)[0]]) {
      onContactListOpen();
    }
  });
};
const requestContactsPermissions = async permissionType => {
  const permissionsManager = new PermissionsManager();
  return await permissionsManager.requestPermissions(undefined, permissionType);
};
const SelectedRecipient = ({
  phone,
  isValid,
  showErrorText,
  mobileNumberRef,
  onPhoneChanged,
  maxLength,
  onContactListPress,
  iconName,
  theme,
  handleOnPressRecipient,
  accounts,
  phoneNumberValidation,
  setIsValidTopupNumber,
  setPhoneNo,
  userType,
  ...props
}) => {
  const [isValidPhoneNumber, setIsValidPhoneNumber] = useState(true);
  const [isShowErrorText, setIsShowErrorText] = useState(false);
  const validationTimeoutRef = useRef();

  useEffect(() => {
    setIsValidTopupNumber(false);
  }, []);
  const validatePhoneNumber = phoneNo => {
    if (phoneNo === '') {
      setIsValidTopupNumber(false)
    }
    setIsShowErrorText(false);
    setIsValidPhoneNumber(true);
    clearTimeout(validationTimeoutRef?.current);
    if (phoneNo.length >= 5) {
      validationTimeoutRef.current = setTimeout(() => {
        if (phoneNo) {
          if (phoneNumberValidation(phoneNo)) {
            setPhoneNo(phoneNo);
            setIsValidPhoneNumber(true);
            setIsShowErrorText(false);
            setIsValidTopupNumber(true);
          } else {
            setIsValidPhoneNumber(false);
            setIsShowErrorText(true);
            setIsValidTopupNumber(false);
          }
        }
      }, 800);
    }
  };

  const hasAccounts = !!_get(accounts, 'length', 0);

  return (
    <View>
      {hasAccounts ? (
        <View>
          <View style={styles.textContainer(theme)}>
            <VFText style={styles.titleStyle(theme)} i18nKey="top_up_someone_else_section_title" />
          </View>
          <ScrollView horizontal showsHorizontalScrollIndicator={false}>
            {_map(accounts, (item, index) => {
              const isLastItem = index === accounts.length - 1;
              return (
                <SubTrayItemView
                  key={`SubTray-Card-${index}-${item.name}`}
                  {...item}
                  onPress={() => handleOnPressRecipient(item.phone, item.name)}
                  itemTitle={item.name}
                  itemSubTitle={item.phone}
                  image={item.image}
                  containerViewStyle={styles.containerViewStyle(isLastItem)}
                />
              );
            })}
          </ScrollView>
        </View>
      ) : null}
      <View style={styles.newRecipientView(theme, _get(accounts, 'length', 0))}>
        <NewRecipient
          phone={phone}
          isValid={isValidPhoneNumber}
          showErrorText={isShowErrorText}
          mobileNumberRef={mobileNumberRef}
          onPhoneChanged={validatePhoneNumber}
          maxLength={maxLength}
          onContactListPress={() => checkContactsPermission(onContactListPress)}
          iconName={iconName}
          accounts={accounts}
        />
      </View>
    </View>
  );
};
SelectedRecipient.defaultProps = {
  theme: LightThemeColors,
};
SelectedRecipient.propTypes = {
  phone: PropTypes.string,
  isValid: PropTypes.bool,
  showErrorText: PropTypes.bool,
  mobileNumberRef: PropTypes.string,
  onPhoneChanged: PropTypes.func,
  maxLength: PropTypes.number,
  onContactListPress: PropTypes.func,
  iconName: PropTypes.string,
  theme: PropTypes.shape({
    name: PropTypes.string,
    isDark: PropTypes.bool,
    colors: PropTypes.object,
  }),
  handleOnPressRecipient: PropTypes.func,
  accounts: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string,
      type: PropTypes.string,
      image: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
      phone: PropTypes.string,
    }),
  ),
  isValidPhoneNumber: PropTypes.bool,
  phoneNumberValidation: PropTypes.func,
  setIsValidTopupNumber: PropTypes.func,
  setPhoneNo: PropTypes.func,
  userType: PropTypes.oneOf(Object.values(User_Types)),
};
export default withTheme(SelectedRecipient);
export { requestContactsPermissions, checkContactsPermission };
